// extracted by mini-css-extract-plugin
export var actionButton = "_xc-2";
export var card = "_xc-0";
export var errorCard = "_xc-3";
export var row = "_xc-1";